import { Schedule, ScheduleStore } from "@sportal/api";

export interface SchedulesSlice {
  keys: string[];
  list: {
    [key: string]: ScheduleStore;
  };
  blockedCategories: {
    [profileId: string]: string[];
  };
}

export interface SchedulesState {
  saved: SchedulesSlice;
  changed: SchedulesSlice;
}

interface AddPauseInternetSuccessAction {
  type: typeof PAUSE_INTERNET_SUCCESS;
  payload: { profileId: string; schedule: Schedule };
}

interface ResumePausedInternetSuccessAction {
  type: typeof RESUME_INTERNET_SUCCESS;
  payload: { scheduleId: string };
}

export type SchedulesActionTypes =
  | AddPauseInternetSuccessAction
  | ResumePausedInternetSuccessAction;

export const GET_SCHEDULES_SUCCESS = "[SCHEDULES] GET_SCHEDULES_SUCCESS";
export const ADD_SCHEDULE_RULE = "[SCHEDULES] ADD_SCHEDULE_RULE";
export const EDIT_SCHEDULE_RULE = "[SCHEDULES] EDIT_SCHEDULE_RULE";
export const TOGGLE_SCHEDULE_ENABLED = "[SCHEDULES] TOGGLE_SCHEDULE_ENABLED";
export const DELETE_SCHEDULE_RULE = "[SCHEDULES] DELETE_SCHEDULE_RULE";
export const CHANGE_CATEGORIES = "[SCHEDULES] CHANGE_CATEGORIES";
export const SAVE_SCHEDULES_SUCCESS = "[SCHEDULES] SAVE_SCHEDULES_SUCCESS";
export const DISCARD_SCHEDULE_CHANGES = "[SCHEDULES] DISCARD_SCHEDULE_CHANGES";

export const PAUSE_INTERNET = "[SCHEDULES] PAUSE_INTERNET";
export const PAUSE_INTERNET_SUCCESS = "[SCHEDULES] PAUSE_INTERNET_SUCCESS";

export const RESUME_INTERNET = "[SCHEDULES] RESUME_INTERNET";
export const RESUME_INTERNET_SUCCESS = "[SCHEDULES] RESUME_INTERNET_SUCCESS";
